<div class="container">
  <div class="header">
    <h1>Tipos de Agendamento</h1>
    <button mat-raised-button color="primary" (click)="openForm()">
      <mat-icon>add</mat-icon>
      Novo Tipo
    </button>
  </div>

  <div class="content">
    <mat-card>
      <mat-card-content>
        <div *ngIf="isLoading" class="loading-container">
          <mat-spinner diameter="40"></mat-spinner>
        </div>

        <div *ngIf="!isLoading && calendarClasses.length === 0" class="empty-state">
          <mat-icon>event_busy</mat-icon>
          <p>Nenhum tipo de agendamento encontrado</p>
          <button mat-raised-button color="primary" (click)="openForm()">Criar Primeiro Tipo</button>
        </div>

        <table mat-table [dataSource]="calendarClasses" *ngIf="!isLoading && calendarClasses.length > 0" class="mat-elevation-z2 full-width">
          <ng-container matColumnDef="color">
            <th mat-header-cell *matHeaderCellDef>Cor</th>
            <td mat-cell *matCellDef="let item">
              <div class="event-sample"
                   [style.background-color]="getColorSecondary(item.color)"
                   [style.border-left-color]="getColorDarker(item.color)">
                <span [style.color]="item.color">Exemplo</span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef>Descrição</th>
            <td mat-cell *matCellDef="let item">{{ item.description }}</td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Ações</th>
            <td mat-cell *matCellDef="let item">
              <button mat-icon-button color="primary" (click)="openForm(item)" matTooltip="Editar">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="deleteCalendarClass(item)" matTooltip="Excluir">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </mat-card-content>
    </mat-card>
  </div>
</div>
